import connectReCaptchaV3 from './connectReCaptchaV3';
import { ReCaptchaV3 } from './ReCaptchaV3';

export default connectReCaptchaV3(ReCaptchaV3);
